import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { useRefreshToken } from "../../hooks/auth-operations/useRefreshToken";
import { isTokenExpired } from "../../hooks/useApollo";
import { useAuthStore } from "../../stores";
import Loading from "../shared/Loading";

// TODO: Clean up and understand this function better.
function PersistLogin() {
  // Global state.
  const { accessToken } = useAuthStore();

  // Local state
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (error) {
        // Refresh failed - user will need to log in again
      } finally {
        setIsLoading(false);
      }
    };

    // Refresh when the persisted token is missing OR expired. Access tokens
    // live 10 minutes, so on most reloads the stored one is already dead —
    // without this the WebSocket connected anonymously and the filtered
    // subscriptions stayed silent until some query happened to 401.
    if (!accessToken || isTokenExpired(accessToken)) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }
  }, []);

  return isLoading ? <Loading /> : <Outlet />;
}

export default PersistLogin;
